<template lang="pug">
IndexOriginal
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/stores/main'
import { useSiteConfigStore } from '@/stores/siteConfig'
import { storage } from '@/utils/storage'

definePageMeta({
  layout: 'default',
  middleware: 'guest',
})

const route = useRoute()
const config = useRuntimeConfig()
const mainStore = useMainStore()
const { setModal, setFriendCode } = mainStore
const { token } = useAuthToken()
const siteConfigStore = useSiteConfigStore()
const { getSiteConfig } = storeToRefs(siteConfigStore)

const configName = config.public.name

const methods = computed(() => {
  return Object.keys(getSiteConfig.value?.loginMethods || {}).map((key) => ({
    name: key,
    config: getSiteConfig.value.loginMethods[key],
  }))
})

const hasPhoneMethod = computed(() => {
  return methods.value.some((method) => method.name === 'phone')
})

const hasEmailMethod = computed(() => {
  return methods.value.some((method) => method.name === 'email')
})

onMounted(() => {
  if (!token.value) {
    setModal('ModalPanelLogin')
  }
})
</script>
<style lang="scss" scoped></style>
